import { Popover as NextUIPopover } from '@nextui-org/react';
import styled from 'styled-components';

import { ChevronIcon } from '../../assets';
import { ThemeProp } from '../../theme/Themes';
import Button from '../Button';
import SecondaryButton from '../Button/SecondaryButton';

export const DropdownWrapper = styled.div<{ $labelPosition: 'top' | 'left' }>`
  display: flex;
  flex-direction: ${({ $labelPosition }) => ($labelPosition === 'left' ? 'row' : 'column')};
  align-items: ${({ $labelPosition }) => ($labelPosition === 'left' ? 'center' : 'flex-start')};
  gap: ${({ $labelPosition }) => ($labelPosition === 'left' ? '0.75rem' : '0.25rem')};
`;

export const DropdownLabel = styled.span`
  font-family: ${({ theme }: ThemeProp) => theme.fonts.primary};
  font-size: ${({ theme }: ThemeProp) => theme.fontVariants.desktop.body2.fontSize};
  font-style: normal;
  font-weight: ${({ theme }: ThemeProp) => theme.fontWeight.regular};
  line-height: ${({ theme }: ThemeProp) => theme.lineHeight.s};
  color: ${({ theme }: ThemeProp) => theme.colors.content.subdued.high};
`;

export const TriggerButton = styled(Button)<{ $isOpen?: boolean }>`
  height: 2rem;
  width: 9.5rem;
  background: ${({ theme }: ThemeProp) => theme.colors.background};
  color: ${({ theme }: ThemeProp) => theme.colors.content.default};
  border: 1px solid ${({ theme }: ThemeProp) => theme.colors.neutrals.c300};
  border-radius: 0.5rem;

  &:hover,
  &:focus,
  &:active {
    background: ${({ theme }: ThemeProp) => theme.colors.background};
    height: 2rem;
  }
`;

export const TriggerContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 9.5rem;
  padding: 0.75rem;
`;

export const TriggerLabel = styled.span`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 7rem;
`;

export const TriggerChevronContainer = styled.span`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-left: auto;
  flex-shrink: 0;
`;

export const Chevron = styled(ChevronIcon)<{ $isOpen: boolean }>`
  flex-shrink: 0;
  stroke: ${({ theme }: ThemeProp) => theme.colors.neutrals.c500};
  transform: ${({ $isOpen }) => ($isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: transform 0.2s ease;
`;

export const ContentContainer = styled(NextUIPopover.Content)`
  min-width: 14rem;
  max-width: 16rem;
  padding: 0.5rem;
  border: 1px solid var(#e9eaeb);
  border-radius: 0.5rem;
  box-shadow: ${({ theme }: ThemeProp) => theme.shadows.tooltips};
`;

export const SearchContainer = styled.div`
  margin-bottom: 0.5rem;
  padding: 0.5rem;
`;

export const ItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  max-height: 14rem;
  overflow-y: auto;
`;

export const ItemButton = styled.button<{ $isSelected?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  border: none;
  border-radius: 0.375rem;
  text-align: left;
  cursor: pointer;
  padding: 0.5rem 0.625rem;
  background: ${({ theme, $isSelected }: ThemeProp & { $isSelected?: boolean }) =>
    $isSelected ? theme.colors.main.c050 : 'transparent'};

  &:hover {
    background: ${({ theme }: ThemeProp) => theme.colors.main.c050};
  }
`;

export const ItemTitle = styled.div<{ $isSelected?: boolean }>`
  font-size: ${({ theme }: ThemeProp) => theme.fontVariants.desktop.body2.fontSize};
  color: ${({ theme, $isSelected }: ThemeProp & { $isSelected?: boolean }) =>
    $isSelected ? theme.colors.main.c600 : theme.colors.content.default};
`;

export const ItemDescription = styled.div`
  font-size: ${({ theme }: ThemeProp) => theme.fontSize.s};
  color: ${({ theme }: ThemeProp) => theme.colors.content.subdued.high};
`;

export const EmptyState = styled.div`
  padding: 0.5rem;
  color: ${({ theme }: ThemeProp) => theme.colors.content.subdued.high};
  font-size: ${({ theme }: ThemeProp) => theme.fontSize.s};
`;

export const Actions = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 0.75rem;
`;

export const CancelButton = styled(SecondaryButton)`
  flex: 1;
`;

export const ConfirmButton = styled(Button)`
  flex: 1;
`;

export const ItemLeftContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;
`;

export const ItemRightContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 0.5rem;
`;
